import { RegionSurchargeTable } from '@/components/shipping/RegionSurchargeTable';
import type { RegionSurchargeRow } from '@/lib/domain/regionSurcharge';
import type { ShippingFeeRegionSurcharge } from '../types/shippingFee';

interface RegionSurchargeEditorProps {
  surcharges: ShippingFeeRegionSurcharge[];
  disabled: boolean;
  onChange: (surcharges: ShippingFeeRegionSurcharge[]) => void;
}

/** 토글을 처음 켤 때 채울 예시 — 지역명 기준(order V62). */
const seedRows = (): RegionSurchargeRow[] => [
  { areaName: '제주특별자치도', fee: 3000 },
  { areaName: '경상북도 울릉군', fee: 5000 },
];

/**
 * ID50 지역별 추가배송비 — 국내 배송비조건. regionSurchargeEnabled=true 일 때만 노출/저장된다.
 *
 * 매칭 기준은 지역명(label)이다(order V62, 배송지 주소 포함 · 가장 구체적인 1건). 우편번호 앞자리
 * (postalPrefix)는 매칭에 쓰지 않아 입력란을 없앴고, 불러온 값은 id 로 찾아 그대로 되돌려 보낸다.
 * 입력 테이블은 해외 국가그룹과 같은 `RegionSurchargeTable` 을 쓴다.
 */
export const RegionSurchargeEditor = ({ surcharges, disabled, onChange }: RegionSurchargeEditorProps) => {
  const rows: RegionSurchargeRow[] = surcharges.map((s) => ({
    ...(s.id !== undefined ? { id: s.id } : {}),
    areaName: s.label,
    fee: s.surchargeFee,
  }));

  const handleChange = (next: RegionSurchargeRow[]) => {
    const postalById = new Map(surcharges.filter((s) => s.id).map((s) => [s.id, s.postalPrefix]));
    onChange(
      next.map((r) => {
        const postalPrefix = r.id !== undefined ? postalById.get(r.id) : undefined;
        return {
          ...(r.id !== undefined ? { id: r.id } : {}),
          label: r.areaName,
          surchargeFee: r.fee,
          ...(postalPrefix != null ? { postalPrefix } : {}),
        };
      }),
    );
  };

  return (
    <RegionSurchargeTable
      rows={rows}
      onChange={handleChange}
      disabled={disabled}
      seedRows={seedRows}
      testId="region-surcharge-editor"
    />
  );
};
